module.exports = __webpack_public_path__ + "img/m1.cdd3a9b0.jpg";